module.exports = __webpack_public_path__ + "static/img/7960_phase_function_Paper_Points.f0faa58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7960_phase_function_Paper_Points.png
// module id = Mag1
// module chunks = 0